<template>
  <div>
    <base-header type="gradient-rmn" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <groups-table title="Groups"></groups-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GroupsTable from "./Tables/DraggableGroupsTable";
export default {
  name: "groups",
  components: {
    GroupsTable,
  },
};
</script>
<style></style>
